import handler from "./handler";
import render from "./render";

const name = "tree";


export default {handler, render, name};
